import { render } from "./MatrixEditor.vue?vue&type=template&id=5bd8b4a3&scoped=true"
import script from "./MatrixEditor.vue?vue&type=script&lang=js"
export * from "./MatrixEditor.vue?vue&type=script&lang=js"

import "./MatrixEditor.vue?vue&type=style&index=0&id=5bd8b4a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd8b4a3"]])

export default __exports__